export default __webpack_public_path__ + "static/media/prize_geprek_nasi_wangi_sambal_matah.6cd5c578.png";